// External URLs configurable per environment. REACT_APP_* values are inlined at
// build time, see frontend/README.md.
const fromEnv = (value) => (value || '').trim().replace(/\/+$/, '');

const CORPORATE_URL = fromEnv(process.env.REACT_APP_CORPORATE_URL) || 'https://www.mailamericas.com';

export const QUOTE_URL = `${CORPORATE_URL}/quote`;
export const PRIVACY_POLICY_URL = `${CORPORATE_URL}/privacy-policy`;
export const TERMS_OF_USE_URL = `${CORPORATE_URL}/terms-of-use`;

export const PREALERT_URL =
  fromEnv(process.env.REACT_APP_PREALERT_URL) ||
  'https://docs.google.com/forms/d/e/1FAIpQLScCg_FRwBWfT-SpgikHtG9jGTbTv3kNKK5sSB90FkW10yAV0Q/viewform';

// No default: the previous form was deleted. Without a URL the page shows the contact e-mail instead.
export const RETURN_PREALERT_URL = fromEnv(process.env.REACT_APP_RETURN_PREALERT_URL);
